import { resolveFileIconType } from "@/utils/utils";
import { Button, Modal, Space, Spin } from "antd";
import { useTranslation } from "react-i18next";
import { generatePath } from "react-router";
import { useGetBugReport } from "../../../../common/api/queries";
import ActionTextIcon from "../../../../common/components/icons/ActionTextIcon";
import type { UUID } from "../../../../typings/global";
import { BUG_REPORT_ROUTE_PATHS } from "../../../bugreport/paths";
import { UserReportedBug } from "../../../bugreport/types";

interface Props {
  open: boolean;
  id: UUID;
  onCancelClick: () => void;
}

export const BugReportNotificationView = ({ open, id, onCancelClick }: Props) => {
  const { t } = useTranslation();

  const { data: bugReport } = useGetBugReport(id, open);

  return (
    <Modal
      open={open}
      title={t("notification.titles.userBugReport")}
      footer={<Button onClick={onCancelClick}>{t("common.close")}</Button>}
      onCancel={onCancelClick}
    >
      {bugReport ? (
        <Space orientation="vertical">
          <h3>{(bugReport.data as UserReportedBug).title}</h3>
          <p>{(bugReport.data as UserReportedBug).content}</p>

          {bugReport.attachments.map((attachment) => (
            <ActionTextIcon
              key={attachment.id}
              icon={resolveFileIconType(attachment.file.contentType)}
              color="blue"
              text={attachment.file.filename}
              path={generatePath(BUG_REPORT_ROUTE_PATHS.attachment.to, { id1: bugReport.id, id2: attachment.id })}
              target="_blank"
            />
          ))}
        </Space>
      ) : (
        <Spin spinning size="large" />
      )}
    </Modal>
  );
};
